/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Pricedrops72h1Inputs */

const id_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penurunan harga (72j)`)
};

const ms_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penurunan harga (72j)`)
};

const da_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfald (72t)`)
};

const de_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preissenkungen (72h)`)
};

const en_us2_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price drops (72h)`)
};

const es_es2_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caídas de precio (72h)`)
};

const es_mx2_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caídas de precio (72h)`)
};

const fil_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbaba ng presyo (72h)`)
};

const fr_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baisses de prix (72h)`)
};

const it_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calo prezzi (72h)`)
};

const hu_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áresések (72 óra)`)
};

const nl_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijsdalingen (72u)`)
};

const no_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfall (72t)`)
};

const pl_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spadki cen (72h)`)
};

const pt_br2_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quedas de preços (72h)`)
};

const pt_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quedas de preço (72h)`)
};

const ro_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scăderi de preț (72h)`)
};

const fi_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnanlaskut (72h)`)
};

const sv_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfall (72h)`)
};

const vi_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá (72h)`)
};

const tr_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat düşüşleri (72s)`)
};

const cs_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poklesy cen (72h)`)
};

const bg_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спад на цените (72ч)`)
};

const ru_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снижения цен (за последние 72 часа)`)
};

const uk_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зниження цін (72год)`)
};

const ar_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انخفاضات الأسعار (72 ساعة)`)
};

const hi_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य में गिरावट (72 घंटे)`)
};

const th_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาลดลง (72 ชม.)`)
};

const ja_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値下がり (72時間)`)
};

const zh_cn2_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格降幅 (72h)`)
};

const zh_hant1_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`價格降幅 (72h)`)
};

const ko_home_hero_pricedrops72h1 = /** @type {(inputs: Home_Hero_Pricedrops72h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 인하 (72시간)`)
};

/**
* | output |
* | --- |
* | "Price drops (72h)" |
*
* @param {Home_Hero_Pricedrops72h1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_hero_pricedrops72h1 = /** @type {((inputs?: Home_Hero_Pricedrops72h1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Pricedrops72h1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_hero_pricedrops72h1(inputs)
	if (locale === "ms") return ms_home_hero_pricedrops72h1(inputs)
	if (locale === "da") return da_home_hero_pricedrops72h1(inputs)
	if (locale === "de") return de_home_hero_pricedrops72h1(inputs)
	if (locale === "en-US") return en_us2_home_hero_pricedrops72h1(inputs)
	if (locale === "es-ES") return es_es2_home_hero_pricedrops72h1(inputs)
	if (locale === "es-MX") return es_mx2_home_hero_pricedrops72h1(inputs)
	if (locale === "fil") return fil_home_hero_pricedrops72h1(inputs)
	if (locale === "fr") return fr_home_hero_pricedrops72h1(inputs)
	if (locale === "it") return it_home_hero_pricedrops72h1(inputs)
	if (locale === "hu") return hu_home_hero_pricedrops72h1(inputs)
	if (locale === "nl") return nl_home_hero_pricedrops72h1(inputs)
	if (locale === "no") return no_home_hero_pricedrops72h1(inputs)
	if (locale === "pl") return pl_home_hero_pricedrops72h1(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_pricedrops72h1(inputs)
	if (locale === "pt") return pt_home_hero_pricedrops72h1(inputs)
	if (locale === "ro") return ro_home_hero_pricedrops72h1(inputs)
	if (locale === "fi") return fi_home_hero_pricedrops72h1(inputs)
	if (locale === "sv") return sv_home_hero_pricedrops72h1(inputs)
	if (locale === "vi") return vi_home_hero_pricedrops72h1(inputs)
	if (locale === "tr") return tr_home_hero_pricedrops72h1(inputs)
	if (locale === "cs") return cs_home_hero_pricedrops72h1(inputs)
	if (locale === "bg") return bg_home_hero_pricedrops72h1(inputs)
	if (locale === "ru") return ru_home_hero_pricedrops72h1(inputs)
	if (locale === "uk") return uk_home_hero_pricedrops72h1(inputs)
	if (locale === "ar") return ar_home_hero_pricedrops72h1(inputs)
	if (locale === "hi") return hi_home_hero_pricedrops72h1(inputs)
	if (locale === "th") return th_home_hero_pricedrops72h1(inputs)
	if (locale === "ja") return ja_home_hero_pricedrops72h1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_hero_pricedrops72h1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_pricedrops72h1(inputs)
	return ko_home_hero_pricedrops72h1(inputs)
});
export { home_hero_pricedrops72h1 as "home.hero.priceDrops72h" }